import { Injectable } from '@angular/core';

import { Infills } from '../../model/infills';
import { alignObjectBetweenTwoPosts } from '../../../utils/align-object-between-two-posts';
import { StageService } from '../../../../stage.service';
import { InfillsKindsUtilsService } from './infills-kinds-utils.service';
import { getBaserailLevelPosPoint } from '../../../utils/get-baserail-level-pos-point';
import { getHandrailLevelPosPoint } from '../../../utils/get-handrail-level-pos-point';

declare const THREE: any;

@Injectable()
export class InfillsClipByFourPointService {
  constructor(
    private stageService: StageService,
    private infillsUtilsService: InfillsKindsUtilsService
  ) {}

  clipAndPlaceInfill(
    pos1,
    pos2,
    model,
    baserail,
    handrail,
    allInfills: any,
    infillType: Infills,
  ): {
    infill: any;
    firstPoint: any;
    secondPoint: any;
    thirdPoint: any;
    fourthPoint: any;
  } {
    const obj = model.clone();
    obj.visible = true;
    alignObjectBetweenTwoPosts(obj, pos1, pos2);
    this.stageService.add(obj);
    allInfills.push(obj);

    const firstPoint = getBaserailLevelPosPoint(baserail, infillType, pos1);
    const secondPoint = getBaserailLevelPosPoint(baserail, infillType, pos2);
    const thirdPoint = getHandrailLevelPosPoint(handrail, pos2);
    const fourthPoint = getHandrailLevelPosPoint(handrail, pos1);

    obj.position.set(
      (pos1.x + pos2.x) / 2,
      (firstPoint.y + secondPoint.y) / 2 + (fourthPoint.y - firstPoint.y) / 2,
      (pos1.z + pos2.z) / 2
    );

    // Local placeholder panels (flat alpha-textured sheet) are clipped a bit
    // wider than the opening so their edges tuck into the posts and rails —
    // otherwise the seam is visible on all four sides. Frame positions and the
    // returned points still use the exact opening.
    let clipFirst = firstPoint;
    let clipSecond = secondPoint;
    let clipThird = thirdPoint;
    let clipFourth = fourthPoint;
    if (obj.userData.entity && obj.userData.entity.localAsset) {
      const overlap = 2; // cm
      const dir = secondPoint
        .clone()
        .setY(firstPoint.y)
        .sub(firstPoint)
        .normalize();
      const up = new THREE.Vector3(0, 1, 0);
      clipFirst = firstPoint.clone().addScaledVector(dir, -overlap).addScaledVector(up, -overlap);
      clipSecond = secondPoint.clone().addScaledVector(dir, overlap).addScaledVector(up, -overlap);
      clipThird = thirdPoint.clone().addScaledVector(dir, overlap).addScaledVector(up, overlap);
      clipFourth = fourthPoint.clone().addScaledVector(dir, -overlap).addScaledVector(up, overlap);
    }

    obj.traverse(c => {
      if (c && c.material) {
        c.material = c.material.clone();
        this.infillsUtilsService.clipInfillMaterialByFourPoints(
          clipFirst,
          clipSecond,
          clipThird,
          clipFourth,
          [c.material],
          (c.name !== "frameLeft" && c.name !== "frameRight")
        );
      }
    });

    return  {
      infill: obj,
      firstPoint,
      secondPoint,
      thirdPoint,
      fourthPoint
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/kinds/tools/infills-clip-by-four-points.service.ts